import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=6494804b&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=6494804b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6494804b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6494804b')) {
      api.createRecord('6494804b', component.options)
    } else {
      api.reload('6494804b', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=6494804b&scoped=true", function () {
      api.rerender('6494804b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/Logo.vue"
export default component.exports